import { errorToast } from "@/v2-ui/toast"
import Switch, { type SwitchProps } from "@/v2-ui/switch"
import { useLayerEnableMutation } from "@/v2-backoffice-client/layer/enable/layer.enable.mutation"
import type { LayerFragment } from "@/v2-backoffice-client/layer/__types__/layer.fragment"
import { LAYER_COUNTS_QUERY_NAME } from "@/v2-backoffice-client/layer/counts/layer.counts.constants"

export type LayerEnableSwitchProps = SwitchProps & {
  layer: LayerFragment
}

export function LayerEnableSwitch(props: LayerEnableSwitchProps) {
  const { layer, ...switchProps } = props

  const [toggle, { loading, error }] = useLayerEnableMutation({
    refetchQueries: [LAYER_COUNTS_QUERY_NAME],
  })
  errorToast(error, {
    title: "Failed to toggle layer enable/disable",
  })

  return (
    <Switch
      isLoading={loading}
      checked={layer.IsEnabled}
      onCheckedChange={(checked) => {
        toggle({
          variables: {
            featureCode: layer.FeatureCode,
            isEnabled: checked,
          },
        })
      }}
      {...switchProps}
    />
  )
}

export default LayerEnableSwitch
